// A positive backend flag enables its label; absent/negative flags never do.
export function backendBadgeLabel(value: unknown, enabledLabel?: string): string | null {
  if (value === true) return enabledLabel ?? null;
  if (typeof value !== 'string') return null;
  const label = value.trim();
  if (/^true$/i.test(label)) return enabledLabel ?? null;
  return label && !/^(false|null|undefined)$/i.test(label) ? label : null;
}
